import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ReportSchedule from './view/report-schedule';
import ReportScheduleUpdate from './form/report-schedule-update';

const ReportScheduleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ReportSchedule />} />
    <Route path="new" index element={<ReportScheduleUpdate />} />
    <Route path=":id">
      <Route index element={<ReportScheduleUpdate />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ReportScheduleRoutes;
